import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, JhiLanguageService } from 'ng-jhipster';

import { EventReservation } from './event-reservation.model';
import { EventReservationPopupService } from './event-reservation-popup.service';
import { EventReservationService } from './event-reservation.service';
import { CRUD_ACTIONS } from '../../shared/index';

@Component({
    selector: 'jhi-event-reservation-delete-dialog',
    templateUrl: './event-reservation-delete-dialog.component.html'
})
export class EventReservationDeleteDialogComponent {

    eventReservation: EventReservation;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private eventReservationService: EventReservationService,
        public activeModal: NgbActiveModal,
        private eventManager: EventManager
    ) {}

    clear() {
        this.activeModal.dismiss('cancel');
    }

    confirmDelete(id: number) {
        this.eventReservationService.delete(id).subscribe(response => {
            this.eventManager.broadcast({
                name: 'eventParticipantsListModification',
                content: {
                    action: CRUD_ACTIONS.DELETE,
                    content: {id: id}
                }
            });
            this.activeModal.dismiss(true);
        });
    }
}

@Component({
    selector: 'jhi-event-reservation-delete-popup',
    template: ''
})
export class EventReservationDeletePopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor(
        private route: ActivatedRoute,
        private eventReservationPopupService: EventReservationPopupService
    ) { }

    ngOnInit() {
        this.routeSub = this.route.params.subscribe(params => {
            this.modalRef = this.eventReservationPopupService
                .open(EventReservationDeleteDialogComponent as Component, params['id']);
        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/event-reservation/event-reservation-delete-dialog.component.ts